module.exports = __webpack_public_path__ + "static/media/bronze.3790e608.webp";